import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
const CustomDatePicker = ({parentCallBack, isDateTimePicker, parentDate})=>{
    const [Component, setComponent] = useState(null);

    useEffect(()=>{
        if(Platform.OS==='web'){
            import('./CustomDatePickerWebComponent').then((module)=>{
                const DatePickerWeb = module.default;
                setComponent(()=>
                    <DatePickerWeb 
                        parentCallBack = {parentCallBack}
                        isDateTimePicker={isDateTimePicker}
                        parentDate={parentDate} 
                    />)
            });
        }else{
            import('./CustomDatePickerRNComponent').then((module)=>{
                const DatePickerRN = module.default;
                setComponent(()=>
                    <DatePickerRN 
                        parentCallBack = {parentCallBack}
                        isDateTimePicker={isDateTimePicker}
                        parentDate={parentDate} 
                    />)
            });
        }

    },[parentCallBack]);

    if(!Component){
        return null;
    }

    return Component;
}

export default CustomDatePicker